module.exports = __webpack_public_path__ + "img/yi_2020.974bd402.png";